import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { ErroRequisicao } from './api/cliente'
import { configurarFilaDeEnvio } from './envio/fila-de-envio'
import { configurarFilaDeAcoes } from './envio/fila-de-acoes-em-massa'
import { avisarRecusa } from './componentes/AvisoDeRecusa'
import './estilos/index.css'

const cliente = new QueryClient({
  /*
    Toda ação recusada pelo servidor passa por aqui. A tela que já mostra o erro continua
    mostrando; a que não mostrava deixa de terminar calada (ADR 0074).
  */
  mutationCache: new MutationCache({
    onError: (erro, _variaveis, _contexto, mutacao) =>
      avisarRecusa(erro, mutacao.meta?.silenciosa === true),
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 15_000,
      retry: (tentativas, erro) => {
        // Não adianta insistir em 401 ou 403.
        if (erro instanceof ErroRequisicao && erro.status < 500) return false
        return tentativas < 2
      },
    },
  },
})

// A fila dos 5 segundos vive fora da árvore do React e precisa deste cliente
// para a conversa se atualizar quando a mensagem finalmente sai.
configurarFilaDeEnvio(cliente)
configurarFilaDeAcoes(cliente)

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('elemento #raiz não encontrado')

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
